export default __webpack_public_path__ + "static/media/img4.08def93e.jpg";